export const environment = {
  production: false,
  
  //apiBaseUrl: 'https://dev-app.grintafy.com/', // dev
  apiBaseUrl: 'https://livenodev2.grintafy.com/', // new live for test
};



